import { HttpService } from "../../app/HttpService";
import { DELETE_CONSENT } from "../../utils/constants";

export const deleteConsent = async (consentId) => {

    return await HttpService.delete(DELETE_CONSENT(consentId)).then((resp) => {
    }).catch(console.log)

}